
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","data-token-name":"arrow-down"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10 2.375c.345 0 .625.28.625.625v14a.625.625 0 11-1.25 0V3c0-.345.28-.625.625-.625z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.543 10.038a.625.625 0 01.883-.03L10 16.143l6.574-6.135a.625.625 0 01.852.914l-7 6.533a.625.625 0 01-.852 0l-7-6.533a.625.625 0 01-.03-.884z"}})])
          )
        }
      }
    